module.exports = __webpack_public_path__ + "media/images/basic_logos/file-icon-0e07d8a2d386dbb62bf2c016caa95a0c.svg";